export default "__VITE_ASSET__DlTLtHt9__"